import styled from "styled-components";
import themes from "@/styles/themes";

const SuccessCard = styled.div`

  h1 {
    color: ${themes.estadao};
    font-style: italic;
    text-align: center;
    font-size: 26px;
    margin: 20px 0;
    font-weight: bold;
  }
  p{
    font-size: 18px;
    text-align: center;
    color: #2c2c2c;
  }
  div.divider{
    width: 100%;
    display: block;
    height: 1px;
    content: '';
    border-bottom: 1px solid ${themes.estadao};
    margin: 25px 0;
  }
  h5{
    font-size: 18px;
    font-weight: 700;
    color: ${themes.estadao};
    margin: 15px 0 ;
  }
`

export default SuccessCard